<template>
    <v-dialog
    :value="value"
    @input="v => v || closeShowPvsystLasDialog()"
    max-width="1500px"
    >
    <v-data-table
      disable-pagination
      hide-default-footer
      :headers="pvsystLasTableHeaders"
      :items="pvsystLasFiles"
      :loading="loading"
      loading-text="ローディング..."
      no-data-text="該当データがありません。"
      class="elevation-1 mt-3"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title style="padding-top: 20px;">
            <b>点群ファイル一覧</b>
            <v-spacer></v-spacer>
            <span style="font-size:17px;">オルソ画像名:{{pvsyst_las_data.file_app}}_{{pvsyst_las_data.file_name}}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeShowPvsystLasDialog()" >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.origin_las_path="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-btn class="download" text @click="download(item.origin_las_path)" v-bind="attrs" v-on="on">
              <span
                class="text-truncate"
                style="max-width: 200px;"
              >{{ getTextOriginalLasName(item)}}
              </span>
            </v-btn>
          </template>
          <h5>{{ getTextOriginalLasName(item)}}</h5>
        </v-tooltip>
      </template>
      <template v-slot:item.without_outlier_path="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-btn class="download" text @click="download(item.without_outlier_path)" v-bind="attrs" v-on="on">
              <span
                class="text-truncate"
                style="max-width: 200px;"
              >{{ getTextPvsystLasName(item.without_outlier_path)}}
              </span>
            </v-btn>
          </template>
          <h5>{{ getTextPvsystLasName(item.without_outlier_path)}}</h5>
        </v-tooltip>
      </template>
      <template v-slot:item.points_merge_path="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-btn class="download" text @click="download(item.points_merge_path)" v-bind="attrs" v-on="on">
              <span
                class="text-truncate"
                style="max-width: 200px;"
              >{{ getTextPvsystLasName(item.points_merge_path)}}
              </span>
            </v-btn>
          </template>
          <h5>{{ getTextPvsystLasName(item.points_merge_path)}}</h5>
        </v-tooltip>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
            v-if="item.status === 'LAS_QUEUEING'"
            color="secondary"
            small
        >
          {{ getPvsystLasStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'LAS_PROCESSING'"
            color="primary"
            small
        >
          {{ getPvsystLasStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'LAS_COMPLETED'"
            color="success"
            small
        >
          {{ getPvsystLasStatusText(item.status) }}
        </v-chip>
        <v-chip
            v-if="item.status === 'LAS_ERROR'"
            color="error"
            small
        >
          {{ getPvsystLasStatusText(item.status) }}
        </v-chip>
      </template>
      <template v-slot:item.created_user="{ item }">
        {{ item.created_user.split('@')[0] }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-right">
          <v-btn
            color="error"
            text
            @click="confirmDeletePvsystLas(item)"
          >削除</v-btn>
        </div>
      </template>
    </v-data-table>
    </v-dialog>
</template>
<script>
import {store} from "@/store";
export default {
  name: "H2pShowPvsystLasDialog",
  props: ["value", "pvsyst_las_data"],
  data() {
    return {
        loading: true,
        pvsystLasTableHeaders: [
            {
            text: "オリジナル点群",
            sortable: false,
            value: "origin_las_path",
            },
            {
            text: "オルソ画像点群",
            sortable: false,
            value: "without_outlier_path",
            },
            {
            text: "周辺地形",
            sortable: false,
            value: "points_merge_path",
            },
            {
            text: "作成者",
            sortable: false,
            value: "created_user",
            },
            {
            text: "日付",
            sortable: true,
            value: "updated_at",
            },
            {
            text: "状態",
            sortable: false,
            value: "status",
            },
            {
            text: "アクション",
            sortable: false,
            value: "actions",
            align: "center",
            },
        ],
        pvsystLasFiles: [],
    };
  },
  methods: {
    resetData() {
        this.loading = true;
        this.pvsystLasFiles = [];
    },
    getPvsystLas() {
      this.resetData();
      this.axios.get("/api/h2p/pvsyst-las/"+this.pvsyst_las_data.id).then((response) => {
        this.loading = false;
        this.pvsystLasFiles = response.data.pvsyst_lases;
      });
    },
    getPvsystLasStatusText(type) {
      const pvsystLasStatusTypes = [
        {text: "作成待ち", value: "LAS_QUEUEING"},
        {text: "作成中", value: "LAS_PROCESSING"},
        {text: "作成完了", value: "LAS_COMPLETED"},
        {text: "エラー", value: "LAS_ERROR"},
      ];
      return pvsystLasStatusTypes.find(x => x.value == type).text;
    },
    getTextPvsystLasName(item) {
      if(item) {
        return item.split('/')[item.split('/').length -1];
      } else {
        return "";
      }
    },
    getTextOriginalLasName(item) {
      return item.las_app +'_'+ item.las_name;
    },
   
    closeShowPvsystLasDialog() { 
        this.$emit("input");
    },
    confirmDeletePvsystLas(item) {
      const confirmDialog = {
        title: '削除確認',
        content:  "データを削除します。よろしいですか。",
        onAgree: () => {
          this.axios
              .delete("/api/h2p/pvsyst-las/"+ item.id)
              .then((response) => {
                if(response.status === 204) {
                  store.showSuccessDialog("データ削除が完了しました。");
                  this.getPvsystLas();
                }
              })
              .catch(() => {
                  store.showErrorDialog("エラーが発生しました。再度試してください。");
              });
        },
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    download(path) {
      this.axios
      .post("/api/h2p/download", { path: path })
      .then((response) => {
        window.location.href = response.data;
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
      });
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.getPvsystLas();
      }
    },
  },
};
</script>
<style scoped>
.v-application .mt-3 {
    margin-top: 0px !important;
}
</style>
